import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ProcessedResult from './report-generation-module/ProcessedResult';
import DownloadPdf from './report-generation-module/DownloadPdf';
import { FullscreenProvider } from './context/FullScreenContext';
import ProtectedRoute from './protected-route/ProtectedRoute';
import NoAccess from './protected-route/NoAccess';
import StartInspection
  from './camera-module/instructions-module/StartInspection';
import VideoInstruction
  from './video-module/instructions-module/VideoInstruction';
// import ViewAudit from "./view-audit/ViewAudit";
import Inspection from './audit-creation-module/Inspection';
// import CameraModuleUpdated from "./components/imageCategories/UpdatedCameraCopy";
import Login from './login-module/login';
import CameraModule from './camera-module/Camera';
import ImageAnalyzer from './components/TestCams/ImageTester';
import ImageUploadPopUp from './camera-module/ImageUploadPopUp';
import SuccessComponent from './audit-completion-module/SuccessComponent';
import Permission from './camera-module/location-camera-permission/Permission';
import VideoRecorder from './video-module/VideoModule';

import Processing from './audit-completion-module/Processing';
import TestCache from './components/TestCams/TestCache';
import InternetSignal from './components/TestCams/InternetSignal';
import InspectionMethod
  from './audit-creation-module/inspection-mode/InspectionMethod';
import PermissionVideo
  from './video-module/location-camera-audio-permission/Permission';
import StartInspectionVideo
  from './video-module/instructions-module/StartInspection';
import VideoTimer from './video-module/video-timer/VideoTimer';
import ProcessingVideo from './audit-completion-module/video-module-completion/Processing';
import ShareAuditOptions from './components/TestCams/ShareAuditOptions';
import ShareOptions from './components/TestCams/ShareAuditOptions';
import WebcamVideo from './components/TestCams/ImageTester';
import WebPagePdf from './report-generation-module/WebPagePdf'
import Photo_Video_Instruction from './camera-module/photo_video_instruction/Photo_Video_Instruction';
import SpeedTest from "./components/TestCams/NetworkCheck"
import DynamicResolutionWebcam from './components/TestCams/NetworkCheck';
import PermissionHybrid from './hybrid-mode-module/location-camera-permission/Permission';
import StartInspectionHybrid from './hybrid-mode-module/instructions-module/StartInspection';
import CameraModuleHybrid from './hybrid-mode-module/Camera';
import ProcessingHybrid from './audit-completion-module/hybrid-module-completion/Processing';
import Introduction from './intro-module/Introduction'
import AuditList from './intro-module/AuditList'
import AuditDescription from './intro-module/AuditDescription';
import UserType from './nativeHelperComponents/userType';
import InputLink from './nativeHelperComponents/pasteLinkComponent';
// import LocationPermission from "./instructions-module/LocationPermission";
function App() {
  return (
    <Router>
      <FullscreenProvider>
        <Routes>

          {/* generic routes for video & photo mode */}
          <Route path="/" element={<Introduction />} />
		  <Route path="/userType" element={<UserType />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auditList" element={<AuditList />} />
          <Route path="/auditDescription" element={<AuditDescription />} />
          <Route path="/home" element={<Inspection />} />
          {/* <Route path="/view-audit" element={<ViewAudit />} /> */}

          {/* photo mode routes */}
          <Route
            exact
            path="/audit/photo/permission/:audit_id"
            element={<ProtectedRoute element={Permission} />}
          />
          <Route
            exact
            path="/audit/photo/:audit_id"
            element={<ProtectedRoute element={StartInspection} />}
          />
          <Route path="/camera" element={<CameraModule />} />

          {/* video mode routes */}
          <Route
            exact
            path="/audit/video/permission/:audit_id"
            element={<ProtectedRoute element={PermissionVideo} />}
          />
          <Route
            exact
            path="/audit/video/:audit_id"
            element={<ProtectedRoute element={StartInspectionVideo} />}
          />
          <Route path="/video_intructions/:audit_id" element={<VideoInstruction />} />
          <Route path="/video/:audit_id" element={<VideoRecorder />} />
          <Route path="/videoTimer" element={<VideoTimer number={3} />} />
          <Route path="/processing/video/:audit_id" element={<ProcessingVideo />} />

          {/* hybrid mode route */}
          <Route
            exact
            path="/audit/hybrid/permission/:audit_id"
            element={<ProtectedRoute element={PermissionHybrid} />}
          />
          <Route
            exact
            path="/audit/hybrid/:audit_id"
            element={<ProtectedRoute element={StartInspectionHybrid} />}
          />
          <Route path="/camera-hybrid" element={<CameraModuleHybrid />} />
          <Route path="/processing/hybrid/:audit_id" element={<ProcessingHybrid />} />
          {/* report generation route */}
          <Route path="/auditInfo/:audit_id" element={<DownloadPdf />} />

          <Route
            exact
            path="/audit/inspection/:audit_id"
            element={< InspectionMethod />}
          />

          <Route path="/no-access" element={<NoAccess />} />
          {/* audit completion route */}
          <Route path="/processing/:audit_id" element={<Processing />} />
          <Route path="/success" element={<SuccessComponent />} />

          {/* test routes */}
          <Route
            exact
            path="/testing"
            element={<DynamicResolutionWebcam />}
          />
          {/* <Route path="/test" element={<ShareOptions url ="https://insurance-inspection.cainatics.in/"/>} /> */}
          {/* <Route path="/test" element={<MyComponent />} /> */}
          <Route path="/test1" element={<WebPagePdf />} />
          <Route path="/test2" element={<VideoInstruction />} />

        </Routes>
      </FullscreenProvider>
    </Router>
  );
}

export default App;
